import { cx } from '@twind/core';
import img from 'app/assets/icons/attention.svg';
import useInputFontSizeClass from 'app/hooks/useInputFontSizeClass';
import { useEffect, useState } from 'react';

import { FormItemInput, InputAttributes, InputTypeHint } from '../types';

const inputConfig: Record<InputTypeHint, InputAttributes> = {
  text: {
    type: 'text',
    maxLength: 100,
    inputMode: 'text',
    autoComplete: 'on',
  },
  number: {
    type: 'number',
    inputMode: 'numeric',
  },
  email: {
    type: 'email',
    maxLength: 320,
    inputMode: 'email',
    autoComplete: 'on',
  },
  phone: {
    type: 'tel',
    maxLength: 20,
    inputMode: 'tel',
    autoComplete: 'on',
  },
  'zip-code': {
    type: 'text',
    pattern: '\\d{5}(?:[\\-\\s]\\d{4})?',
    inputMode: 'numeric',
    autoComplete: 'on',
  },
  'email-or-phone': {
    type: 'text',
  },
  'npi-number': {
    type: 'number',
    inputMode: 'numeric',
    autoComplete: 'on',
  },
  multi_line_text: {
    type: 'text',
    maxLength: 150,
  },
};

type Props = {
  item: FormItemInput;
  isSubmitted: boolean;
  isDirty: boolean;
  onChange: (value: string) => void;
};

export function ContactFormInput({ item, isSubmitted, isDirty, onChange }: Props) {
  const fontSizeClass = useInputFontSizeClass();
  const hasErrors = item.errors?.length;
  const [value, setValue] = useState('');

  useEffect(() => {
    setValue((item.value || '') as string);
  }, [item.value]);

  const isMultiLine = item.input_type_hint === 'multi_line_text';
  const InputComponent = isMultiLine ? 'textarea' : 'input';

  const showError = isSubmitted && hasErrors && !isDirty;

  return (
    <div className="flex flex-col gap-2">
      <label
        htmlFor={item.ref_id}
        className="flex text-sm gap-1"
      >
        <div
          dangerouslySetInnerHTML={{
            __html: item.label || '',
          }}
        />
        {!item.required && <span>(optional)</span>}
      </label>
      <InputComponent
        id={item.ref_id}
        style={{
          backgroundPosition: 'right 14px center',
        }}
        required={item.required}
        {...inputConfig[item.input_type_hint as InputTypeHint]}
        className={cx(
          'px-[14px] py-3 border md:text-sm rounded-[8px] hide-number-input-arrows',
          showError ? `(bg-[url(${img})] bg-no-repeat)` : '',
          showError ? 'border-[#FF3323] outline-[#FF3323]' : 'border-typography-divider outline-typography-divider',
          fontSizeClass,
          isMultiLine && 'min-h-[60px]'
        )}
        name={item.ref_id}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          onChange(e.target.value);
        }}
        placeholder={item.placeholder}
      />
      {showError && item.errors?.length ? (
        <div className="text-xs -mt-1 text-[#FF3323]">{item.errors?.join(', ')}</div>
      ) : null}
    </div>
  );
}
